@for (content of contentInput(); track content['_uid']) {
	@if (components) {
		<ndc-dynamic
			[ndcDynamicComponent]="components[content['component']]"
			[ndcDynamicInputs]="content"
		/>
	}
}
